import React, { createContext } from "react";
import _ from "lodash";

class NavigationEmitter {
  constructor() {
    this.observers = [];
  }
  addObserver = (obj) => {
    if (!_.find(this.observers, (o) => o == obj)) {
      this.observers.push(obj);
    }
  };

  emit = ({ event, params }) => {
    _.forEach(this.observers, (observer) => {
      observer.handleNavigationEvent(event, params);
    });
  };
}

export const WebNavigator = new NavigationEmitter();
const WebNavigatorContext = createContext();
export function WebNavigatorContextProvider(props) {
  return (
    <WebNavigatorContext.Provider value={{ WebNavigator: WebNavigator }}>
      {props.children}
    </WebNavigatorContext.Provider>
  );
}

export default WebNavigatorContext;
